var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogosWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_3314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.959329 15.17C0.958642 17.6346 1.60764 20.041 2.8417 22.1621L0.841309 29.4093L8.31581 27.4647C10.3832 28.5814 12.6995 29.1665 15.0533 29.1667H15.0595C22.83 29.1667 29.1553 22.8926 29.1586 15.181C29.1601 11.4442 27.6948 7.93036 25.0326 5.28672C22.3708 2.64331 18.8308 1.18676 15.0589 1.18506C7.28754 1.18506 0.962652 7.45875 0.959444 15.17",
    fill: "url(#paint0_linear_82_3314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.4561 15.165C0.455298 17.7183 1.12756 20.2108 2.40562 22.4079L0.333496 29.9148L8.07601 27.9005C10.2093 29.0546 12.6112 29.6631 15.0553 29.664H15.0616C23.1108 29.664 29.6634 23.1643 29.6668 15.1766C29.6682 11.3055 28.1502 7.66537 25.3929 4.92702C22.6352 2.18902 18.9685 0.680059 15.0616 0.678467C7.01095 0.678467 0.459309 7.17728 0.4561 15.165ZM5.06693 22.0295L4.77784 21.5741C3.56257 19.6568 2.92113 17.4411 2.92205 15.1659C2.92468 8.52672 8.37014 3.12519 15.0662 3.12519C18.3089 3.12655 21.3563 4.38083 23.6485 6.65655C25.9405 8.9325 27.2017 11.9579 27.2009 15.1757C27.1979 21.815 21.7523 27.2172 15.0616 27.2172H15.0568C12.8782 27.216 10.7416 26.6355 8.8782 25.5385L8.43477 25.2775L3.8402 26.4728L5.06693 22.0294V22.0295Z",
    fill: "url(#paint1_linear_82_3314)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4111 9.10821C11.1377 8.50529 10.85 8.49312 10.59 8.48255C10.3771 8.47345 10.1337 8.47413 9.89055 8.47413C9.64718 8.47413 9.25175 8.56498 8.91751 8.92709C8.58293 9.28955 7.64014 10.1655 7.64014 11.9469C7.64014 13.7286 8.94788 15.4502 9.13018 15.6921C9.31271 15.9334 11.6548 19.7063 15.3641 21.1577C18.4468 22.3639 19.0742 22.124 19.7432 22.0635C20.4124 22.0033 21.9024 21.1879 22.2064 20.3423C22.5106 19.4969 22.5106 18.7722 22.4194 18.6207C22.3282 18.4699 22.0848 18.3793 21.7199 18.1982C21.3548 18.0171 19.5607 17.1411 19.2262 17.0203C18.8916 16.8995 18.6484 16.8393 18.405 17.2018C18.1616 17.5638 17.4628 18.3793 17.2498 18.6207C17.037 18.8628 16.824 18.8929 16.4592 18.7118C16.094 18.5301 14.9187 18.1482 13.5243 16.9147C12.4395 15.9549 11.707 14.7697 11.4941 14.4071C11.2812 14.0451 11.4713 13.8488 11.6543 13.6684C11.8183 13.5062 12.0194 13.2456 12.202 13.0342C12.384 12.8227 12.4447 12.6719 12.5664 12.4304C12.6882 12.1887 12.6273 11.9772 12.5362 11.7961C12.4447 11.615 11.7356 9.82415 11.4111 9.10821Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_82_3314",
    x1: 1416.71,
    y1: 2823.61,
    x2: 1416.71,
    y2: 1.18506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60D669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_82_3314",
    x1: 1467,
    y1: 2924.31,
    x2: 1467,
    y2: 0.678467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_3314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.3333,
    height: 29.3333,
    fill: "white",
    transform: "translate(0.333496 0.678467)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosWhatsappIcon);
export default __webpack_public_path__ + "static/media/logos_whatsapp-icon.e807626a4b3331748e004311d4d6aa12.svg";
export { ForwardRef as ReactComponent };